export * from '@primeuix/themes/aura/ripple';
export { default } from '@primeuix/themes/aura/ripple';
